import Table from "../components/industry-conversion-list/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import SearchBar from "../components/industry-conversion-list/SearchBar";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
業態変換一覧画面
 */
const IndustryConversion = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <SearchBar />
      <Table />
    </SpaceBetween>
  );
};

export default IndustryConversion;
